<template>
  <div class="form-group">
    <label
      v-bind:class="{
        'text-danger': current.errors && current.errors.proveedor,
      }"
      >Linea de vehículo</label
    >
    <v-select
      label="nombre"
      v-model="current.linea"
      :disabled="disabled"
      :filterable="false"
      :options="vehiculos"
      @search="onSearch"
    >
      <template slot="no-options">Linea...</template>
      <template slot="option" slot-scope="option">
        <div class="selected d-center">
          {{ option.id }} - {{ option.nombre }}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center">
          {{ option.id }} - {{ option.nombre }}
        </div>
      </template>
    </v-select>
    <small
      v-if="current.errors && current.errors.proveedor"
      class="form-text text-danger"
      >{{ current.errors.proveedor }}</small
    >
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";

export default {
  props: ["current", "disabled"],
  data() {
    return {
      vehiculos: []
    }
  },
  computed: {},
  mounted() {
    let self = this;
    self.refreshData();
  },
  methods: {
    refreshData() {
      let self = this;
      DynamicService.fetch("cat", "vehiculo-linea", {
        page: 1,
      }).then((res) => {
        self.vehiculos = res.data.results;
      });
    },
    onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      DynamicService.fetch("cat", "vehiculo-linea", {
        page: 1,
        quitar_paginacion: true,
        "filter[search]": search,
      }).then((res) => {
        vm.vehiculos = res.data;
        loading(false);
      });
    }, 350),
  },
};
</script>